var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "31px",
    viewBox: "0 0 28 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7D451700-0CA1-4A10-942F-A29AE7360F55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual-Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Board",
    transform: "translate(-1157.000000, -1409.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-LogOut",
    transform: "translate(1157.000000, 1409.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38047493,23 C7.45435356,23 7.52638522,22.986852 7.59656992,22.960556 C7.66675462,22.93426 7.72770449,22.8910594 7.77941953,22.8309542 C7.89023747,22.7182569 7.94564644,22.5830203 7.94564644,22.4252442 C7.94564644,22.2674681 7.89023747,22.1322314 7.77941953,22.0195342 L1.93931398,16.0803907 L20.4237467,16.0803907 C20.5862797,16.0803907 20.7229551,16.0240421 20.8337731,15.9113449 C20.944591,15.7986476 21,15.663411 21,15.5056349 C21,15.3403456 20.944591,15.2013524 20.8337731,15.0886551 C20.7229551,14.9759579 20.5862797,14.9196093 20.4237467,14.9196093 L1.93931398,14.9196093 L7.77941953,8.98046582 C7.89023747,8.8677686 7.94564644,8.73253193 7.94564644,8.57475582 C7.94564644,8.41697971 7.89023747,8.28174305 7.77941953,8.16904583 C7.66860158,8.05634861 7.53562005,8 7.38047493,8 C7.22532982,8 7.09234828,8.05634861 6.98153034,8.16904583 L0.166226913,15.0886551 C0.055408971,15.2013524 0,15.3384673 0,15.5 C0,15.6615327 0.055408971,15.7986476 0.166226913,15.9113449 L6.98153034,22.8309542 C7.03324538,22.8910594 7.09419525,22.93426 7.16437995,22.960556 C7.23456464,22.986852 7.30659631,23 7.38047493,23 Z",
    id: "a",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6733124,0 C25.5497863,0 27.8937321,2.21152909 27.996487,4.97725512 L28,5.16666667 L28,25.8333333 C28,28.6233941 25.7199759,30.8969245 22.8685904,30.9965925 L22.6733124,31 L18.0653375,31 C17.4769679,31 17,30.5373609 17,29.9666667 C17,29.4316408 17.41921,28.9915853 17.9564129,28.9386683 L18.0653375,28.9333333 L22.6733124,28.9333333 C24.3814824,28.9333333 25.7766608,27.6335149 25.8648949,25.9979711 L25.869325,25.8333333 L25.869325,5.16666667 C25.869325,3.50981242 24.5292488,2.15654704 22.8430493,2.07096369 L22.6733124,2.06666667 L18.0653375,2.06666667 C17.4769679,2.06666667 17,1.60402757 17,1.03333333 C17,0.498307482 17.41921,0.0582519769 17.9564129,0.00533498351 L18.0653375,0 L22.6733124,0 Z",
    id: "Rectangle"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6b558d1175eca7b9a2bcba2688eff887.svg";
export { ForwardRef as ReactComponent };